/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function (cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

ShopifyAPI.addMultipleItems = function (data, callback, errorCallback) {
  console.log('running..')
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      beforeSend: function (jqxhr, settings) {
        $body.trigger('beforeAddItem.ajaxCart');
      },
      success: function (line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        } else {
          ShopifyAPI.onItemAdded(line_item);
        }
        $body.trigger('afterAddItem.ajaxCart', [line_item]);
      },
      error: function (XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      },
      complete: function (jqxhr, text) {
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {

  var $body = $(document.body);
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function () {
      $body.trigger('beforeAddItem.ajaxCart');
    },
    success: function (line_item) {

      if ((typeof callback) === 'function') {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }

      if (line_item.variant_id == 673920516097) {
        location.reload();
      } else {
        $body.trigger('afterAddItem.ajaxCart', [line_item]);
      }

      if ($(window).width() > 1024) {
        $('#CartContainer').addClass("opened");

        setTimeout(function () {
          $('#CartContainer').removeClass("opened");
        }, 3000);
      } else {

        $('.mobile_cart_popup').show();
        setTimeout(function () {
          $('.mobile_cart_popup').hide();
        }, 5000);

        var formVarId = parseInt($(form).attr('data-variantId'));
        var has_sub = $(form).attr('data-subsc');

        if (line_item.variant_id == 36234547713 || line_item.variant_id == 33187743873 || line_item.variant_id == formVarId) {} else {
          $(form).find('#AddToCart').find('span').first().text('Added to bag!');
          $(".mob_subscr_popup").removeClass("active");
          $(form).find('#AddToCart').find('span.btn-price').hide();
          setTimeout(function () {
            $(form).find('#AddToCart').find('span').first().text('Add to bag');
            $(form).find('#AddToCart').find('span.btn-price.main').show();
            $(".mob_order_opt").hide();
            if (has_sub == 'true') {
              $(".mob_add_cart").find("button").attr("type", "button").addClass("mob_add_btn");
            }
          }, 3000);
        }
      }
      var formVarId = parseInt($(form).attr('data-variantId'));
      if (line_item.variant_id == 36234547713 || line_item.variant_id == 33187743873 || line_item.variant_id == formVarId) {

        $(".kit_pr").find('.kit_btn').find('span').text('Already in cart');
        $(".kit_pr").find('.kit_btn').prop('disabled', true).removeAttr('id');
      }

      var selevar = parseInt($(form).attr('data-varid'));
      console.log("line_item.variant_id " + line_item.variant_id + " v selevar " + selevar);
      if (line_item.variant_id == selevar) {
        $(form).find('.reebok_btn').text('Gift added');
        $(form).find('.reebok_btn').attr('type', 'button');
        $(form).find('.reebok_btn').removeAttr('id');

        $(form).find('.diskvry_btn').text('added');
        $(form).find('.diskvry_btn').attr('type', 'button');
        $(form).find('.diskvry_btn').removeAttr('id');

      }
    },
    error: function (XMLHttpRequest, textStatus) {

      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function (jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    },
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON(window.ORW.shopUrl + '/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function (cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/

/* ===== Emoji Animation Script ===== */
let emojiOne = "//tula-uk.myshopify.com/cdn/shop/t/22/assets/smiling_face_with_hearts.svg?v=27138528564914389371656348210",
    emojiTwo = "//tula-uk.myshopify.com/cdn/shop/t/22/assets/fire.svg?v=30820375570459950381656348175",
    emojiThree = "//tula-uk.myshopify.com/cdn/shop/t/22/assets/fireworks.svg?v=25581299604277924751656348379",
    emojiFour = "//tula-uk.myshopify.com/cdn/shop/t/22/assets/party_popper.svg?v=82690896639778803161656348212",
    emojiFive = "//tula-uk.myshopify.com/cdn/shop/t/22/assets/growing_heart_tula.svg?v=40599096374161567701656348219",
    emojiSix = "//tula-uk.myshopify.com/cdn/shop/t/22/assets/sparkles_one.svg?v=40435391229338244601656348495";
    
let emojiArr = [emojiOne, emojiTwo, emojiThree, emojiFour, emojiFive, emojiSix];

function randomEmoji() {
  let indx = Math.floor((Math.random() * 6) + 1) - 1;
  $(".emojis li img").attr("src", emojiArr[indx]);
}
/* ==== Emoji Animation Script End ==== */


var ajaxCart = (function (module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, checkForOG, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector: '#AddToCartForm',
      cartContainer: '#CartContainer',
      addToCartSelector: '#AddToCart',
      cartCountSelector: '#CartCount',
      cartCostSelector: '#CartCost',
      moneyFormat: '$',
      disableAjaxCart: false,
      enableQtySelectors: true
    };

    // Override defaults with arguments
    $.extend(settings, options || {});

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    formOverride();

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body = $('body');
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    console.log("formOverride");

    $('body').on('click', '#AddToCartNew', function (evt) {
      
      /* Run Emoji Animation */
      randomEmoji();
      $(".emojis li").show();
      setTimeout(function () {
        $(".emoji-wrapper").addClass("active");
      }, 100);
      
      evt.preventDefault();

      var form = $(this).closest('#AddToCartFormNew');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(form, itemAddedCallback, itemErrorCallback);
      
      /* Reset Emoji Animation */
      setTimeout(function () {
        $(".emojis li").hide();
        $('.emoji-wrapper').removeClass("active");
      }, 2200);

    });

    var formCallback = function (evt) {
      
      /* Run Emoji Animation */
      randomEmoji();
      $(".emojis li").show();
      setTimeout(function () {
        $(".emoji-wrapper").addClass("active");
      }, 100);
      
      evt.preventDefault();
      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
      
      /* Reset Emoji Animation */
      setTimeout(function () {
        $(".emojis li").hide();
        $('.emoji-wrapper').removeClass("active");
      }, 2200);
    }

    $formContainer.on('submit', formCallback);

    // jQuery(document).on('submit', '.cross-sell-item .add-to-cart-form', formCallback);
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    if($('body').hasClass('template-cart')){
      window.location.reload(); 
    }
    
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">' + data.description + '</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    checkForOG(cart);
    updateCountPrice(cart);
    buildCart(cart);
  };

  checkForOG = function(cart){
    var has_og = false;
    if(cart){
      $.each(cart.items, function(index, cartItem){
        // console.log(cartItem.properties);
        if(cartItem.properties["og_subscription"] == "true"){
          has_og = true;
        }
      });

      if(has_og){
        $body.addClass('og-in-cart');
        return true;
      }else{
        $body.removeClass('og-in-cart');
        return false;
      }
    }
  };

  buildCart = function (cart) {
    var $cartContainer = $('#CartContainer');
    // Start with a fresh cart div
    $cartContainer.empty();
    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p>' + "Your cart is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    Handlebars.registerHelper('if_eq', function(a, b, opts) {
        if(a == b) // Or === depending on your needs
            return opts.fn(this);
        else
            return opts.inverse(this);
    });
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      pr_count = 0,
      routine_price = 0,
      routine_discount = 0,
      routine_price_multiplier = 1,
      template = Handlebars.compile(source),
      has_event = 'false';
    var event_pr = "";
    var promo_pr = "aqua-infusion-power-liquid-memorial-day-2019-gwp";
    var promo_price = 0;

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      if (cartItem.properties && ('everyday_routine' in cartItem.properties)) {
        pr_count = pr_count + 1;
        routine_price += cartItem.price;
      }

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      if (cartItem.image != null) {
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var title = cartItem.product_title;
      var handle = cartItem.handle;
      var cart_pr_url = cartItem.url;

      if (title == 'FREE Discovery Kit for Reebok VIPs w/ code REEBOKVIP' || promo_pr == handle) {
        cart_pr_url = 'javascript:void()';
      } else if (title == 'SKIN ESSENTIALS TRIAL KIT') {
        cart_pr_url = '/pages/skin-essentials-trial-kit';
      }

      if (promo_pr == handle) {
        promo_price = cartItem.price;
      }

      var event_pro = event_pr.split(',');

      for (var i = 0; i <= event_pro.length; i++) {
        if (event_pro[i] == title) {
          has_event = 'true';
        }
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cart_pr_url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.final_price, settings.moneyFormat),
        vendor: cartItem.vendor
      };

      items.push(item);
      // }
    });

    $cartCountSelector.html(cart.item_count - pr_count).removeClass('hidden-count');

    if (cart.item_count === 0) {
      $cartCountSelector.addClass('hidden-count');
    }

    // calculate cart total, factoring in promo price

    var cart_total = cart.total_price - promo_price;

    // Gather all cart data and add to DOM

    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart_total, settings.moneyFormat),
    };

    $cartContainer.append(template(data));

    // calculate overall routine price

    if (pr_count > 2) {
      for (var i = 0; i < pr_count; i += 1) {
        if (i === 3) routine_discount += 10;
        else routine_discount += 5;
      }
    }

    routine_price_multiplier -= (routine_discount / 100).toFixed(2);
    routine_price *= routine_price_multiplier;

    $('.main_routine_pr').find('.price_qnt').html(Shopify.formatMoney(routine_price, settings.moneyFormat));

    $('.routine_pr_drawer').hide();

    cartCallback(cart);

    var free_price = '40';

      var e_gift_cards = cart.items.filter(function (item) {
        return /e[- ]?gift ?card/i.test(item.title);
      });

      var new_free = parseFloat(free_price) * 100;
      var ship_total = e_gift_cards.length === cart.items.length
        ? new_free
        // uncomment below to exclude gift cards in free shipping calculation
        : cart_total; // - e_gift_cards.reduce(function (prev, curr) { return prev + curr.price }, 0);

      var needs_shipping = e_gift_cards.length !== cart.items.length;
      var ordergroove_check = checkForOG(cart);

      if (ordergroove_check == true) {
          $('#CartContainer .free_note.bottom span').text('Enjoy FREE SHIPPING with auto-delivery');
          $('.free_note.bottom').show();
          $('.mobile_cart_popup').find('.error_note_ship').hide();
      } else if (ship_total >= new_free) {
        var showOrHide = needs_shipping ? 'show' : 'hide';
        $cartContainer.find('.free_note')[showOrHide]();
        $('.mobile_cart_popup').find('.free_note')[showOrHide]();
        $cartContainer.find('.error_note_ship').hide();
        $('.mobile_cart_popup').find('.error_note_ship').hide();
      } else {
          var minus = new_free - ship_total;
          $cartContainer.find('.error_note_ship span').html(Shopify.formatMoney(minus, settings.moneyFormat));
          $cartContainer.find('.error_note_ship').show();
          $cartContainer.find('.free_note').hide();

          $('.mobile_cart_popup').find('.error_note_ship span').html(Shopify.formatMoney(minus, settings.moneyFormat));
          $('.mobile_cart_popup').find('.error_note_ship').show();
          $('.mobile_cart_popup').find('.free_note').hide();
      }
  };

  cartCallback = function (cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function () {
      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    //remove from cart
    $(".site-header__cart-toggle").on('click', '.remove_item', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $el = $(this),
        line = $el.data('line');
      //console.log(line);
      if ($el.parents('.cart_item').hasClass('main_routine_pr')) {
        console.log('routine');
        $el.parents('.cart_item').find('.product-quantity').val('0');
        $('.routine_pr_drawer').find('.product-quantity').val('0');
        setTimeout(function () {
          $('#CartContainer').find('.update-cart').trigger('click');
        }, 1000);
      } else {
        console.log('Not routine');
        updateQuantity(line, 0);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function () {
      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function () {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function (cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function () {
      ShopifyAPI.getCart(buildCart);
    }, 150)
    checkForOG(cart);
  };

  createQtySelectors = function () {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function () {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#AjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function () { 
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr('name'),
          inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function () {
        var $el = $(this),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);
        var maxQty = 5;
        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
          if (qty > maxQty) qty = maxQty;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    var maxQty = 5;
    if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else if (parseInt(qty) > maxQty) {
      // Number too large. Default to 5 (maxQty).
      qty = maxQty;
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
